<template>
  <section>
    <!--工具条-->
    <el-col :span="20" class="toolbar">
      <el-date-picker
        v-model="beginTime"
        type="datetime"
        placeholder="开始时间"
        size="small"
        format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
      <el-date-picker
        v-model="endTime"
        type="datetime"
        placeholder="结束时间"
        size="small"
        format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
        <el-col :span="3">
      <el-input placeholder="店铺名称" size="small" v-model="query">
      </el-input>
    </el-col>

      <el-button type="primary"  size="small" @click="search">查询</el-button>
      <el-button size="small"  @click="export2Excel">导出数据</el-button>
      <el-button type="success"  size="small" >{{profitSum}}</el-button>

    </el-col>
  

   <el-table :data="tableData"
              border
              v-loading="listLoading">
        <el-table-column
        label="ID"
        prop="arrid"
        align="center">
      </el-table-column>
      <el-table-column
        label="分销编号"
        prop="usid"
        align="center">
      </el-table-column>
       <el-table-column
        label="店铺等级"
        align="center">
        <template scope="scope">
          <div>{{userLevel[scope.row.level]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="店铺名称"
        prop="dianpu_name"
        align="center">
      </el-table-column>
        
              <el-table-column
        label="平均价格"
        prop="avg_price"
        align="center">
      </el-table-column>
        <el-table-column
        label="订单数量"
        prop="num"
        align="center">
      </el-table-column>
      <el-table-column
            label="销售额"
               prop="sum_price"
            align="center">
            <template scope="scope">   
        <el-button type="primary" v-if="scope.row.sum_price < 1001"  size="small" >{{scope.row.sum_price}}</el-button>
      <el-button type="danger" v-else-if="scope.row.sum_price > 10000"  size="small" >{{scope.row.sum_price}}</el-button>
      <el-button type="warning" v-else-if="scope.row.sum_price > 5000"  size="small" >{{scope.row.sum_price}}</el-button>
        <el-button type="success" v-else-if="scope.row.sum_price > 1000"  size="small" >{{scope.row.sum_price}}</el-button>
      </template>
    </el-table-column>
             <el-table-column
            label="产出额"
               prop="sum_profit"
            align="center">
            <template scope="scope">   
        <el-button type="primary" v-if="scope.row.sum_profit < 101"  size="small" >{{scope.row.sum_profit}}</el-button>
      <el-button type="danger" v-else-if="scope.row.sum_profit > 1000"  size="small" >{{scope.row.sum_profit}}</el-button>
      <el-button type="warning" v-else-if="scope.row.sum_profit > 500"  size="small" >{{scope.row.sum_profit}}</el-button>
        <el-button type="success" v-else-if="scope.row.sum_profit > 100"  size="small" >{{scope.row.sum_profit}}</el-button>
      </template>
    </el-table-column>
               <el-table-column
        label="利润率"
        prop="profit_margin"
        align="center">
      </el-table-column>
          <el-table-column 
            label="店铺备注" 
            prop="remark" align="center">
      </el-table-column>
     <el-table-column label="操作" prop="labels" align="center">
        <template scope="scope">
            <el-button type="primary" size="small" @click="showOrder(scope.row.usid, '')">查看订单</el-button>
        </template>
      </el-table-column>
      
    </el-table>



  </section>
</template>

<script>
  import config from '../../config';
  import {formatPara} from '../../static/js/util.js';
    import basicdata from '../../static/config/basicdata.js'
import {formatDate} from '../../static/js/date.js';
 
  export default {
    data() {
      return {
        tableData: [],
        listLoading: false,
        query: '',
        beginTime: '',
        profitSum: '',
        userLevel: basicdata.userLevel,
        endTime: '',
      }

    },
    methods: {
    
      search() {
        this.getMovingPinList(this.query);
      },
        showOrder(usid, orderNum) {
        this.$router.push('/order/list/'+usid+'/'+orderNum);
      },
      export2Excel() {
        this.search();
          let url = config.api_url + '/order/partnerbrand';
            this.beginTime = typeof(this.beginTime) != "string" ? formatDate(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
            this.endTime = typeof(this.endTime) != "string" ? formatDate(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
            var query = this.beginTime + "|" + this.endTime+ "|" + this.query ;
            this.$axios.post(url, {
              "query": query
            }).then(response => {
             let data = response.data;
              if(data.state) {
            if(data.msg) {
              console.log(response.data.msg);
              require.ensure([], () => {
                const { export_json_to_excel } = require('../../static/vendor/Export2Excel');
                  const tHeader = ['分销编号','店铺段位', '店铺名称', '平均价格', '订单数量', '销售额', '产出额', '利润率', '店铺备注']; //对应表格输出的title
                const filterVal = ['usid', 'level_str', 'dianpu_name', 'avg_price', 'num', 'sum_price', 'sum_profit', 'profit_margin', 'remark'];  //对应表格输出的数据
                const list = response.data.msg;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, '品牌合伙_'+'_'+this.query+'_'+ '开始时间_'+this.beginTime+'_'+ '结束时间_'+this.endTime+'_'+ '导出时间_'+new Date().toLocaleString()); //对应下载文件的名字
              });
            } else {
              this.$message({
                message: '无数据，请联系管理员！',
                type: 'warning'
              });
            }
          } else {
            this.$message({
              message: '无数据，请联系管理员！',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '导出异常，请联系管理员！',
            type: 'error'
          });
        });
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]));
      },
      getMovingPinList(query) {
        this.listLoading = true;
        let url = config.api_url + '/order/partnerbrand';
    
            this.beginTime = typeof(this.beginTime) != "string" ? formatDate(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
            this.endTime = typeof(this.endTime) != "string" ? formatDate(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
            var query = this.beginTime + "|" + this.endTime+ "|" + query ;
            this.$axios.post(url, {
              "query": query
            }).then(response => {
              let data = response.data;
              if(data.state) {
                this.tableData = data.msg;
                 this.profitSum = data.count;
                this.listLoading = false;
              } 
             })
          }
      },
     created() {
      this.search();
     }
  
  }
</script>

<style scope>
  .goods-data {
    cursor: default;
    background: #fff;
    border: 1px solid #d1dbe5;
    height: 100px;
    overflow-y: scroll;
  }
  .hidden {
    display: none;
  }
  .nohidden {
    display: block;
  }
  .el-checkbox {
    margin-left: 20px;
    margin-top: 7px;
  }
  .user-font {
    font-weight: 600;
    font-size: 15px;
    color: #48576a;
  }
</style>



// WEBPACK FOOTER //
// partnerbrand.vue?28c6cefa